/**
 * Generated by orval 🍺
 * Do not edit manually.
 * clarityrcm.api
 * OpenAPI spec version: 1.0
 */
import type { PracticeProfileResponse } from "../../../../../lib/api-types/schemas";

import { authenticatedClient } from "../../authenticatedClient";

export type getApiPracticesPracticeIdResponse200 = {
  data: PracticeProfileResponse;
  status: 200;
};

export type getApiPracticesPracticeIdResponse401 = {
  data: void;
  status: 401;
};

export type getApiPracticesPracticeIdResponse403 = {
  data: void;
  status: 403;
};

export type getApiPracticesPracticeIdResponse404 = {
  data: void;
  status: 404;
};

export type getApiPracticesPracticeIdResponseSuccess =
  getApiPracticesPracticeIdResponse200 & {
    headers: Headers;
  };
export type getApiPracticesPracticeIdResponseError = (
  | getApiPracticesPracticeIdResponse401
  | getApiPracticesPracticeIdResponse403
  | getApiPracticesPracticeIdResponse404
) & {
  headers: Headers;
};

export const getGetApiPracticesPracticeIdUrl = (practiceId: string) => {
  return `/api/practices/${practiceId}`;
};

/**
 * **Actor types:** `clinic`, `internal`
 *
 * **Practice-scoped:** route `{practiceId}` must match the user's `practiceId` claims
 *
 * The practice id must be a valid practice id.
 * @summary Retrieves the practice profile by practice id.
 */
export const getApiPracticesPracticeId = async (
  practiceId: string,
  options?: Parameters<typeof authenticatedClient>[1],
): Promise<getApiPracticesPracticeIdResponseSuccess> => {
  return authenticatedClient<getApiPracticesPracticeIdResponseSuccess>(
    getGetApiPracticesPracticeIdUrl(practiceId),
    {
      ...options,
      method: "GET",
    },
  );
};
